<template>
  <BTable
    v-bind="$attrs"
    :selected="value"
    :headers="headers"
    :actions="actions"
    :list="list"
    v-on="$listeners || {}"
  >
    <!--  -->

    <template #item.name="{ header, item, value: v }">
      <router-link
        :to="header.getRoute(item)"
        v-text="v"
      />
    </template>

    <template #item.ates="{ value: v }">
      <BTableItemAte :data="v" />
    </template>

    <template #item.is_published="{ value: v }">
      <v-icon v-if="v" color="success">
        mdi-checkbox-marked-outline
      </v-icon>
      <v-icon v-else color="error">
        mdi-close-circle-outline
      </v-icon>
    </template>

    <template #item.is_updated="{ value: v }">
      <v-icon v-if="v" color="success">
        mdi-checkbox-marked-outline
      </v-icon>
      <v-icon v-else color="error">
        mdi-close-circle-outline
      </v-icon>
    </template>

    <!--  -->
  </BTable>
</template>

<script>
import {
  TABLE_HEADERS,
  TABLE_ACTIONS,
} from '@/views/Roadmaps/table-headers'

import BTable from '@/components/common/BTable.vue'
import BTableItemAte from './components/BTableItemAte.vue'


export default {
  name: 'BTableRoadmaps',
  components: {
    BTable,
    BTableItemAte,
  },
  inheritAttrs: false,
  props: {
    value: Array,
    headers: {
      type: Array,
      default: () => TABLE_HEADERS,
    },
    actions: {
      type: Array,
      default: () => TABLE_ACTIONS,
    },
    list: {
      type: Array,
    },
  },
}
</script>
